import 'leaflet'
import Vue from 'vue'

import BasePopup from './BasePopup'
import VueMapPopupRelation from '../../../components/map-popup/map-popup-relation'
import VueMapPopupRelationKursk from '../../../components/map-popup/kursk/map-popup-relation'
import region from '@/utils/region'
import { KURSK } from '@/config/region'

const MapPopupRelation = BasePopup.extend({
  getVueComponent: function () {
    if (region.getCurrentRegion() === KURSK) {
      return new Vue(VueMapPopupRelationKursk)
    } else {
      return new Vue(VueMapPopupRelation)
    }
  },
})

export default MapPopupRelation
